import { render } from "./sydney-health.vue?vue&type=template&id=c8e04b2e"
import script from "./sydney-health.vue?vue&type=script&lang=js"
export * from "./sydney-health.vue?vue&type=script&lang=js"

import "./sydney-health.vue?vue&type=style&index=0&id=c8e04b2e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__